export default __webpack_public_path__ + "static/media/IMG_9900.f3dce9d7.jpg";